/* eslint-disable no-undef */
const isDev = () => {
    if (process.env.REACT_APP_environment === 'DEV') 
        return false;
    else return true;
};
export const _DEV = isDev();
